import { createReducer } from 'immutable-reducers';
import { fromJS, Map } from 'immutable';
import _ from 'lodash';

import { serverVisitToClientMap, serverUnitToClientMap } from 'app/businessRules';
import {VISIT, VISIT_AND_UNITS, STORE_VISIT, STORE_UNIT, DELETE_UNIT, GET_VISIT} from '../constants/actionTypes';


export default createReducer(['visit'], (visit = Map(), action) => {
    let units, index;

    switch (action.type) {

        case STORE_VISIT.SUCCESS:
            let _v = serverVisitToClientMap(action.visit);
            if (!_v.units && visit.has('units')) {
                _v.units = visit.get('units').toJS();
            }
            return fromJS(_v);

        case VISIT_AND_UNITS.SUCCESS:
            return fromJS(serverVisitToClientMap(action.visit));

        case VISIT_AND_UNITS.CLEAR:
            return Map();

        case VISIT.SUCCESS:
            return fromJS(serverVisitToClientMap(action.payload));

        case GET_VISIT.SUCCESS:
            return visit.merge(serverVisitToClientMap(action.visit));

        case STORE_UNIT.SUCCESS:
            let unit = serverUnitToClientMap(action.unit);
            index = 0;
            if (visit.has('units')) {
                units = visit.get('units').toJS();
                index = _.findIndex(units, {trac: unit.trac});
                index = index > -1 ? index : units.length;
            } else {
                units = [];
            }
            units[index] = unit;
            return visit.set('units', fromJS(units));

        case DELETE_UNIT.SUCCESS:
            units = visit.get('units').toJS();
            _.remove(units, {trac: action.trac});
            return visit.set('units', fromJS(units));
        
        default:
            return visit;
    }
});